import { useRoutesContext } from '@src/app/context/Routes/Routes';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { isEmpty, isUndefined } from 'lodash';
import React, { useCallback, useEffect } from 'react';

import { FormSkeleton } from './components/Skeleton';
import fields from './includes/fields.json';

/**
 * Form
 *
 * Provides a form for searching by EID.
 *
 * @param isLoading
 * @returns {Element}
 * @constructor
 */
export function Form({ isLoading = false }) {
  const { currentRoute } = useRoutesContext();
  const router = useRouter();

  const eid =
    !isUndefined(currentRoute?.params?.eid) && !isEmpty(currentRoute?.params?.eid) ? currentRoute?.params?.eid : '';

  const defaultValues = {
    eid,
  };

  const form = useForm({ defaultValues });

  const { isSubmitting, isValid } = form.formState;

  /**
   * If an EID is passed in the URL, set the EID value in the form state.
   */
  useEffect(() => {
    if (!isEmpty(eid)) {
      form.setValue('eid', eid);
    } else {
      form.setValue('eid', '');
      form?.setFocus('eid');
    }
  }, [eid]);

  const handleSubmit = useCallback(
    (submittedValues) => {
      if (!isSubmitting && isValid) {
        router?.navigate(`/analysis/eid-search/${submittedValues?.eid}`);
      }
    },
    [isSubmitting, isValid]
  );

  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Form/Form.jsx">
      <FormProvider autoComplete="off" highlighted onSubmit={handleSubmit} state={form}>
        <Grid css={{ margin: 0 }} id="searchContainer">
          <Grid.Col
            css={{ paddingLeft: 0 }}
            span={{
              xs: '100%',
            }}
          >
            {isLoading ? (
              <FormSkeleton />
            ) : (
              <TextInput
                {...fields?.eid}
                data-testid="search-button"
                highlighted
                onChange={() => {
                  form.validate(
                    `eid`,
                    () => {},
                    () => {}
                  );
                }}
                onClickSearch={() => {
                  handleSubmit(form?.getValues());
                }}
              />
            )}
          </Grid.Col>
        </Grid>
      </FormProvider>
    </ErrorHandler>
  );
}
